'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchItemsIfNeeded = exports.getNextAndPreviousItems = exports.whichCatalogItemsNeeded = exports.getItemIdsForSeller = exports.getItemIdsForCatalog = exports.isItemLoading = exports.getLoadTimeForItem = exports.getItem = exports.LOAD_ITEMS_SUCCESS = exports.LOAD_ITEMS_REQUEST = exports.LOAD_ITEMS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _loaded = require('./loaded');

var _fetchBatch = require('../modules/fetchBatch');

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _user = require('../modules/user');

var _filteredItems = require('../modules/filteredItems');

var _config = require('../modules/config');

var _catalogItems = require('../modules/catalogItems');

var _home = require('../modules/home');

var _sellerRecordResults = require('../modules/sellerRecordResults');

var _similarItems = require('../modules/similarItems');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_ITEMS_FAIL = exports.LOAD_ITEMS_FAIL = 'la/domain/items/LOAD_FAIL';
var LOAD_ITEMS_REQUEST = exports.LOAD_ITEMS_REQUEST = 'la/domain/items/LOAD_REQUEST';
var LOAD_ITEMS_SUCCESS = exports.LOAD_ITEMS_SUCCESS = 'la/domain/items/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');
var FETCH_SET_SIZE = 128;

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_ITEMS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.itemIds)
            });
        case LOAD_ITEMS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case _catalogItems.LOAD_CATALOG_ITEMS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;
            action.payload.forEach(function (item) {
                existing[item.itemId] = (0, _extends3.default)({}, item);
                loaded[item.itemId] = time;
                loading = (0, _difference2.default)(loading, [item.itemId]);
            });
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        case _home.LOAD_HOME_DATA_SUCCESS:
        case LOAD_ITEMS_SUCCESS:
        case _similarItems.LOAD_SIMILAR_ITEMS_SUCCESS:
        case _sellerRecordResults.LOAD_SELLER_RECORD_RESULTS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.items) {
                action.payload.items.forEach(function (item) {
                    existing[item.itemId] = (0, _extends3.default)({}, item);
                    loaded[item.itemId] = time;
                    loading = (0, _difference2.default)(loading, [item.itemId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.item;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// TODO: remove the cloneDeep after the mutation in cardData is fixed
var getItem = exports.getItem = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return (0, _cloneDeep2.default)(byId[id]) || {};
});

var getLoadTimeForItem = exports.getLoadTimeForItem = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isItemLoading = exports.isItemLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var getItemIdsForCatalog = exports.getItemIdsForCatalog = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return (0, _keys2.default)(byId).map(function (key) {
        return byId[key];
    }).filter(function (item) {
        return item.catalogId === id;
    }).map(function (item) {
        return item.itemId;
    });
});

var getItemIdsForSeller = exports.getItemIdsForSeller = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return (0, _keys2.default)(byId).map(function (key) {
        return byId[key];
    }).filter(function (item) {
        return item.sellerId === id;
    }).map(function (item) {
        return item.itemId;
    });
});

var shouldFetchItem = function shouldFetchItem(state, itemId) {
    if (!itemId) return false;
    var item = getItem(state, itemId);
    if (item) {
        var loaded = getLoadTimeForItem(state, itemId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isItemLoading(state, itemId);
    return !loading;
};

var whichItemsNeeded = function whichItemsNeeded(state, itemIds) {
    return itemIds.filter(function (itemId) {
        return shouldFetchItem(state, itemId);
    });
};

var shouldFetchItemsForCatalog = function shouldFetchItemsForCatalog(state, catalogId) {
    if (!catalogId) return false;
    var loaded = (0, _loaded.getLoadTimeForCatalogItems)(state, catalogId);
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME) return false;
    var loading = (0, _loaded.isCatalogItemsLoading)(state, catalogId);
    return !loading;
};

var whichCatalogItemsNeeded = exports.whichCatalogItemsNeeded = function whichCatalogItemsNeeded(state, catalogIds) {
    return catalogIds.filter(function (catalogId) {
        return shouldFetchItemsForCatalog(state, catalogId);
    });
};

var getNextAndPreviousItems = exports.getNextAndPreviousItems = function getNextAndPreviousItems(state, itemId) {
    var item = getItem(state, itemId);
    var lotNumber = item.lotNumber;

    var _getCatalogItems = (0, _filteredItems.getCatalogItems)(state, item.catalogId, {
        sort: 'LOT_NUMBER_LOWEST_FIRST'
    }),
        items = _getCatalogItems.items;

    var previous = {};
    var next = {};
    // eslint-disable-next-line no-plusplus
    for (var i = 0; i < items.length; i++) {
        var current = items[i];
        if (current.item.lotNumber === lotNumber) {
            previous = i - 1 >= 0 ? items[i - 1].item : {};
            next = i + 1 < items.length ? items[i + 1].item : {};
            break;
        }
    }
    return { next: next, previous: previous };
};

/* ACTION CREATORS */
var loadItems = function loadItems(itemIds, loadingId, lastRound) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: itemIds,
                                type: LOAD_ITEMS_REQUEST
                            });
                            _context.next = 7;
                            return _api.Item.fetchItemsByIds({ authToken: authToken, deployment: deployment, itemIds: itemIds });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), itemIds: itemIds },
                                payload: response.data,
                                type: LOAD_ITEMS_SUCCESS
                            });
                            if (lastRound) {
                                dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));
                            }
                            _context.next = 16;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { itemIds: itemIds },
                                payload: _context.t0,
                                type: LOAD_ITEMS_FAIL
                            });
                            dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var loadItemsInSets = function loadItemsInSets(ids, setSize, loadingId) {
    return function (dispatch) {
        if (ids.length > setSize) {
            var newSize = Math.min(8192, setSize * 2);
            return dispatch(loadItems(ids.slice(0, setSize), loadingId, false)).then(function () {
                dispatch(loadItemsInSets(ids.slice(setSize), newSize, loadingId));
            });
        }
        return dispatch(loadItems(ids, loadingId, true));
    };
};

var fetchItemsIfNeeded = exports.fetchItemsIfNeeded = function fetchItemsIfNeeded(itemIds) {
    var loadingId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';

    return function (dispatch, getState) {
        var needed = whichItemsNeeded(getState(), itemIds);
        if (needed.length) {
            dispatch((0, _fetchBatch.loadBatchStart)(loadingId));
            return dispatch(loadItemsInSets(needed, FETCH_SET_SIZE, loadingId));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/item.js
// module id = Gk4U
// module chunks = 46